import Vue from 'vue'
import { sendRequest } from '@/api'
import {
  APP_LOCAL_STORAGE_PREFIX,
  USER_DATA_LOCAL_STORAGE_KEY,

} from '@/const'

const initState = {
  isLogged: false,
  email: null,
  refreshToken: null,
  accessToken: null,
}

export const user = {
  state: initState,
  mutations: {
    setLoggedIn: (state, payload) => {
      const { refreshToken, accessToken, username } = payload
      Vue.set(state, 'accessToken', accessToken)
      Vue.set(state, 'refreshToken', refreshToken)
      Vue.set(state, 'email', username)
      Vue.set(state, 'isLogged', true)
      localStorage.setItem(
        `${APP_LOCAL_STORAGE_PREFIX}_${USER_DATA_LOCAL_STORAGE_KEY}`,
        JSON.stringify(state)
      )
    },
    setLoggedOut: (state) => {
      Vue.set(state, 'accessToken', null)
      Vue.set(state, 'refreshToken', null)
      Vue.set(state, 'email', null)
      Vue.set(state, 'isLogged', false)
      localStorage.setItem(
        `${APP_LOCAL_STORAGE_PREFIX}_${USER_DATA_LOCAL_STORAGE_KEY}`,
        JSON.stringify(state)
      )
    },
    refreshToken: (state, payload) => {
      const { refreshToken, accessToken } = payload
      Vue.set(state, 'accessToken', accessToken)
      Vue.set(state, 'refreshToken', refreshToken)
    },
  },
  actions: {
    login: async (context, payload) => {
      const { email: username, password } = payload
      const { data: { data, meta } } = await sendRequest(
        'post',
        'api/login/',
        { username, password }
      )
      console.log('LOGIN meta', meta)
      if (meta.status === 'ok') {
        const { refresh: refreshToken, access: accessToken } = data
        context.commit('setLoggedIn', { refreshToken, accessToken, username })
      } else {
        alert('Błąd autoryzacji')
      }
    },
    logout: (context) => {
      context.commit('setLoggedOut')
    },
    loadUserData: (context, payload) => {
      const { email: username, refreshToken, accessToken } = payload
      context.commit('setLoggedIn', { refreshToken, accessToken, username })
    },
    refreshToken: (context, payload) => {
      context.commit('refreshToken', payload)
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.isLogged
    },
  },
}